const ClassicGreece = {
  id: '4',
  name: 'Classic Greece'
};

export default ClassicGreece;
